import React from 'react';
import ReactDOM from 'react-dom';
import 'nes.css/css/nes.min.css';
import './sass/index.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
